import { clsx } from 'clsx';
import { type PropsWithChildren, type ReactNode } from 'react';

import { ELEMENTS_IDS } from '@/packages/hybrid-search-page-layout';

import styles from './Layout.css';

export function Layout({ children }: PropsWithChildren): ReactNode {
  return <main className={styles['layout']}>{children}</main>;
}

type SectionProps = {
  children: Array<ReactNode> | ReactNode;
  /**
   * @default white
   */
  bgc?: 'white' | 'gray';
};

Layout.Section = function Section(props: SectionProps): ReactNode {
  const { children, bgc = 'white' } = props;

  return (
    <section className={clsx(styles['section'], styles[`section-bgc-${bgc}`])}>
      <div className={styles['section-inner']}>{children}</div>
    </section>
  );
};

type SectionWithMapProps = {
  children: Array<ReactNode> | ReactNode;
  isMapOpen: boolean;
  isNarrow: boolean;
  isResponsive?: boolean;
  map: JSX.Element;
};

Layout.SectionWithMap = function SectionWithMap(props: SectionWithMapProps): ReactNode {
  const { children, isNarrow, map, isResponsive } = props;

  return (
    <section className={styles['split-section']}>
      <div
        className={clsx(
          styles['listing-section'],
          isNarrow && styles['is-narrow'],
          isResponsive && styles['is-responsive'],
        )}
        id={ELEMENTS_IDS.listingNodeId}
      >
        <div className={styles['listing-section-inner']}>{children}</div>
      </div>
      {map}
    </section>
  );
};

Layout.Footer = function Footer({ children }: PropsWithChildren): ReactNode {
  return (
    <Layout.Section>
      <div className={styles['footer-content']}>{children}</div>
    </Layout.Section>
  );
};
